import { render } from "./AIMLItsPricingComp.vue?vue&type=template&id=db8b8b28&scoped=true"
import script from "./AIMLItsPricingComp.vue?vue&type=script&lang=js"
export * from "./AIMLItsPricingComp.vue?vue&type=script&lang=js"

import "./AIMLItsPricingComp.vue?vue&type=style&index=0&id=db8b8b28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8b8b28"]])

export default __exports__